import { useRef } from "react";

export const TABS = [
  {
    id: "rwo",
    label: "RWO Task List",
  },
  {
    id: "dwo",
    label: "DWO Task List",
  },
] as const satisfies ReadonlyArray<{
  id: string;
  label: string;
}>;

export type TabId = (typeof TABS)[number]["id"];

export const isTabId = (value: string | null): value is TabId =>
  TABS.some((t) => t.id === value);

interface TabNavProps {
  active: TabId;
  onChange: (id: TabId) => void;
}

export const TaskTab = ({ active, onChange }: TabNavProps) => {
  const refs = useRef<Record<string, HTMLButtonElement | null>>({});

  return (
    <div className="border-b border-slate-200">
      <div
        role="tablist"
        aria-label="Employee attendance sections"
        className="-mb-px flex gap-1 overflow-x-auto"
      >
        {TABS.map(({ id, label }) => {
          const isActive = id === active;
          return (
            <button
              key={id}
              ref={(el) => {
                refs.current[id] = el;
              }}
              id={`tab-${id}`}
              role="tab"
              type="button"
              aria-selected={isActive}
              aria-controls={`panel-${id}`}
              tabIndex={isActive ? 0 : -1}
              onClick={() => onChange(id)}
              className={[
                "group relative flex shrink-0 items-center gap-2 px-4 py-3 text-sm font-semibold",
                "border-b-2 transition-colors outline-none",
                "focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-t-md",
                isActive
                  ? "border-primary text-primary bg-primary/10"
                  : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800",
              ].join(" ")}
            >
              <span className="hidden sm:inline">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
